<template>
    <div class="row mt-1">
        <div class="col-lg-6 mb-1">
            <label class="form-label">Tutanak Seri No <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="ReportNumber" :watch="value.ReportNumber">
                <input class="form-control" :disabled="editing" :class="{ 'is-invalid': isReportNumberInvalid }" placeholder="Örn: AB12345678" v-model="value.ReportNumber" />
                <div v-if="isReportNumberInvalid" class="invalid-feedback d-block">Tutanak numarası 2 harf ile başlamalı ve 8 rakam ile devam etmelidir.</div>
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Ceza Tarihi <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="FineDate" :watch="value.FineDate">
                <v-date-picker
                    for-back
                    type="datetime"
                    v-model="value.FineDate"
                    placeholder="Ceza Tarihi"
                    :disabled="editing"
                    v-on:change="
                        getLocation();
                        getTrafficFines();
                        employee = null;
                        value.Banka2 = false;
                    "
                    :disabled-date="disableFutureDates"
                ></v-date-picker>
            </v-validator>
        </div>
        <div class="col-lg-12 mb-1">
            <label class="form-label">Trafik Cezası <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="TrafficFineId" :watch="trafficFine">
                <v-select-list :disabled="!value.FineDate || editing" v-model="trafficFine" :loading="tfLoading" label="Clause" placeholder="Trafik Cezası" :options="trafficFines">
                    <template #option="option">
                        <div class="traffic-fine-option">
                            <strong class="text-secondary">{{ option.Clause }}</strong> - {{ option.Description }}
                        </div>
                    </template>
                </v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1" v-if="$safe(trafficFine, 'Description')">
            <div class="alert alert-dark mb-0">
                <div class="alert-body">
                    {{ $safe(trafficFine, "Description") }}
                </div>
            </div>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Ceza Tutarı (TL)</label>
            <v-currency-input input-class="text-right" :disabled="changeDisable" :value="value.FineAmount" v-on:update-value="(v) => (value.FineAmount = v)"></v-currency-input>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Ceza Puanı</label>
            <v-currency-input input-class="text-right" :disabled="true" :value="trafficFine != null ? trafficFine.Point : null"></v-currency-input>
        </div>
        <div class="col-md-12 mb-1">
            <label class="form-label">Plaka <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="PlateId" :watch="plate">
                <v-select-list v-model="plate" :disabled="editing" placeholder="Plaka" label="PlateValue" v-on:input="getLocation()" :options="plates" />
            </v-validator>
        </div>
        <template v-if="!gettingLocation">
            <template v-if="locationMessage == null">
                <div class="col-md-6 mb-1">
                    <label class="form-label">Enlem</label>
                    <v-validator :errors="errors" parameter="Latitude" :watch="value.Latitude">
                        <input class="form-control" placeholder="Enlem" :disabled="editing" v-model="value.Latitude" disabled />
                    </v-validator>
                </div>
                <div class="col-md-6 mb-1">
                    <label class="form-label">Boylam</label>
                    <v-validator :errors="errors" parameter="Longitude" :watch="value.Longitude">
                        <input class="form-control" placeholder="Boylam" :disabled="editing" v-model="value.Longitude" disabled />
                    </v-validator>
                </div>
                <div class="col-md-12 mb-1">
                    <label class="form-label">Adres</label>
                    <v-validator :errors="errors" parameter="Address" :watch="value.Address">
                        <textarea class="form-control" placeholder="Adres" :disabled="editing" v-model="value.Address" disabled />
                    </v-validator>
                </div>
            </template>
            <template v-else>
                <div class="col-12 mb-1">
                    <div class="alert alert-danger mb-0">
                        <div class="alert-body">
                            {{ locationMessage }}
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="col-12 mb-1">
                <div class="alert alert-secondary mb-0">
                    <div class="alert-body">Lokasyon bilgisi getiriliyor...</div>
                </div>
            </div>
        </template>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Personel <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                <v-select-list
                    v-model="employee"
                    :options="employees"
                    v-on:search="searchEmployees"
                    label="Combine"
                    placeholder="Aramak için personel adı giriniz..."
                    :loading="employeeLoading"
                    :filterable="false"
                >
                </v-select-list>
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Personel Sicil Numarası</label>
            <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                <input class="form-control" v-model="regNumber" v-on:search="searchEmployees" label="Combine" placeholder="Personel Sicil Numarası" :loading="employeeLoading" disabled />
            </v-validator>
        </div>
        <div class="col-lg-12 mb-1" v-if="employee">
            <div :class="['alert', 'mb-0', getPointsAlertClass]">
                <div class="alert-body p-75">
                    <div class="d-flex justify-content-between align-items-center">
                        <div><strong>Mevcut Ceza Puanı:</strong> {{ employee.TrafficFinePoints || 0 }} / 100</div>
                        <div class="text-right"><strong>Kalan Puan:</strong> {{ remainingPoints }}</div>
                    </div>
                    <div class="text-danger text-center mb-0 mt-50 p-25" style="border: 1px dashed red" v-if="shouldShowWarning">
                        <feather-icon icon="AlertTriangleIcon" class="mr-50" />
                        <strong>UYARI:</strong> Bu personelin ceza puanı kritik seviyede! <small>({{ employee.TrafficFinePoints || 0 }} puan)</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Tebliğ Kaynağı <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="NotifyOrigin" :watch="notifyOrigin">
                <v-select-list v-model="notifyOrigin" :disabled="editing" placeholder="Tebliğ Kaynağı" label="text" :options="notifyOrigins" />
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label class="form-label">Tebliğ Tarihi <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="NotifyDate" :watch="value.NotifyDate">
                <v-date-picker v-model="value.NotifyDate" :disabled="editing" placeholder="Tebliğ Tarihi" :disabled-date="disableTebligDates"></v-date-picker>
            </v-validator>
        </div>
        <div class="col-lg-6 mb-1">
            <label :class="['form-label', amountsMismatch ? 'text-danger' : '']">Personel Ödeme Miktarı</label>
            <v-currency-input :value="localDriverAmount" v-on:update-value="($v) => (localDriverAmount = $v)" />
        </div>

        <div class="col-lg-6 mb-1">
            <label :class="['form-label', amountsMismatch ? 'text-danger' : '']">Firma Ödeme Miktarı</label>
            <v-currency-input :value="localCompanyAmount" v-on:update-value="($v) => (localCompanyAmount = $v)" />
        </div>

        <div class="col-12" v-show="amountsMismatch">
            <div class="alert alert-danger mb-1">
                <div class="alert-body">
                    <feather-icon icon="AlertTriangleIcon" class="mr-50" />
                    <strong>UYARI:</strong> Personel + Firma tutarları, ceza tutarına eşit olmalı.
                </div>
            </div>
        </div>
        <div class="col-lg-12 mb-1 mt-25">
            <label class="form-label">Açıklama</label>
            <v-validator :errors="errors"  parameter="Description" :watch="value.Description">
                <textarea class="form-control" rows="3" :disabled="editing" placeholder="Açıklama ekleyebilirsiniz..." v-model="value.Description"></textarea>
            </v-validator>
        </div>
        <div class="col-lg-12">
            <label class="form-label">Belge <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="Document" :watch="value.Document">
                <v-file-uploader v-model="value" :accept="['pdf']" value-parameter="Document"></v-file-uploader>
            </v-validator>
        </div>
        <div class="col-lg-12 mt-1">
            <b-form-checkbox :disabled="employee == null || $safe(employee, 'CollarStatusCode') != null || editing" v-model="value.Banka2">Banka 2</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormSpinbutton, BFormCheckbox } from "bootstrap-vue";
import SystemData from "@/api/system-data";
import EmployeeOperationsApi from "@/api/employee-operations";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VFileUploader from "@/components/v-file-uploader/VFileUploader.vue";
import SystemDataApi from "@/api/system-data";
import BankApi from "@/api/bank";
import VehicleOperationsApi from "@/api/vehicle-operations";
import moment from 'moment'

export default {
    components: {
        BFormSpinbutton,
        VCurrencyInput,
        BFormCheckbox,
        VFileUploader,
    },
    props: {
        value: Object,
        errors: Object,
        companyName: String,
        editing:Boolean
    },
    data() {
        return {
            notifyOrigins: [
                { text: "GİB", value: 0 },
                { text: "Posta", value: 1 },
                { text: "Sürücü", value: 2 },
            ],
            showPointWarning: false,
            currentPoints: 0,
            isCalculating: false,
            localDriverAmount: null,
            localCompanyAmount: null,
            trafficFines: [],
            employeeLoading: false,
            employees: [],
            paymentPlaces: [
                { text: "Vergi Dairesi", value: 0 },
                { text: "Banka", value: 1 },
            ],
            banks: [],
            taxAdministrations: [],
            searchOnTableTimer: null,
            regNumber: null,
            gettingLocation: false,
            plates: [],
            locationMessage: null,
            tfLoading: false,
        };
    },
    watch: {
        "value.FineAmount"() {
            this.setDiscount();
        },

        "value.FineDate"(val) {
            if (val) {
                this.getTrafficFines();
                this.getLocation();
                if (this.value.NotifyDate && new Date(this.value.NotifyDate) < new Date(val)) {
                    this.value.NotifyDate = null;
                }
            } else {
                this.trafficFines = [];
            }
        },

        "value.DriverAmount"(newValue) {
            if (!this.isCalculating) {
                this.localDriverAmount = newValue;
            }
        },
        "value.CompanyAmount"(newValue) {
            if (!this.isCalculating) {
                this.localCompanyAmount = newValue;
            }
        },
        value: {
            handler(newValue) {
                if (!this.isCalculating) {
                    this.localDriverAmount = newValue.DriverAmount;
                    this.localCompanyAmount = newValue.CompanyAmount;
                }
            },
            immediate: true,
            deep: true,
        },
        localDriverAmount(newValue) {
            if (this.isCalculating) return;

            this.isCalculating = true;

            const total = Number(this.value.FineAmount || 0);
            let driverVal = Number(newValue || 0);

            if (driverVal < 0) {
                driverVal = 0;
                this.$nextTick(() => {
                    this.localDriverAmount = 0;
                });
            }

            if (driverVal > total) {
                driverVal = total;
                this.$nextTick(() => {
                    this.localDriverAmount = total;
                });
            }

            const companyVal = total - driverVal;
            this.value.DriverAmount = driverVal;
            this.value.CompanyAmount = companyVal;
            this.localCompanyAmount = companyVal;

            this.$nextTick(() => {
                this.isCalculating = false;
            });
        },
        localCompanyAmount(newValue) {
            if (this.isCalculating) return;

            this.isCalculating = true;

            const total = Number(this.value.FineAmount || 0);
            let companyVal = Number(newValue || 0);

            if (companyVal < 0) {
                companyVal = 0;
                this.$nextTick(() => {
                    this.localCompanyAmount = 0;
                });
            }

            if (companyVal > total) {
                companyVal = total;
                this.$nextTick(() => {
                    this.localCompanyAmount = total;
                });
            }

            const driverVal = total - companyVal;
            this.value.CompanyAmount = companyVal;
            this.value.DriverAmount = driverVal;
            this.localDriverAmount = driverVal;

            this.$nextTick(() => {
                this.isCalculating = false;
            });
        },
    },
    mounted() {
        this.getTrafficFines();
        this.getBanks();
        this.getTaxAdministrations();
        this.getPlates();
        if (this.value.Employee) {
            this.searchEmployees(this.value.Employee.FullName);
        }
        if (this.value.Id && this.value.PlateId && this.value.FineDate) {
            this.getLocation();
        }
    },
    methods: {
        disableTebligDates(date) {
            const today = new Date();
            today.setHours(23, 59, 59, 999);
            if (date > today) {
                return true;
            }

            if (this.value.FineDate) {
                const fineDateStart = new Date(this.value.FineDate);
                fineDateStart.setHours(0, 0, 0, 0);
                if (date < fineDateStart) {
                    return true;
                }
            }

            return false;
        },
        disableFutureDates(date) {
            const endOfToday = new Date();
            endOfToday.setHours(23, 59, 59, 999);
            return date > endOfToday;
        },
        clearTaxAndBank() {
            this.value.BankId = null;
            this.value.TaxAdministrationId = null;
        },
        setDiscount() {
            if (this.value.FineAmount) {
                this.$set(this.value, "DiscountedFineAmount", this.value.FineAmount);
            } else {
                this.$set(this.value, "DiscountedFineAmount", null);
            }
        },
        getTrafficFines() {
            if (this.value.FineDate) {
                this.tfLoading = true;
                SystemData.TrafficFineByDate(this.value.FineDate)
                    .then((res) => {
                        this.trafficFines = res.data.Data;
                        this.tfLoading = false;
                    })
                    .catch((err) => {
                        this.tfLoading = false;
                    });
            }
        },
        searchEmployees(searchKey) {
            if (searchKey) {
                const search = () => {
                    this.employeeLoading = true;
                    clearTimeout(this.searchOnTableTimer);
                    this.searchOnTableTimer = setTimeout(() => {
                        this.employeeLoading = true;
                        EmployeeOperationsApi.Employee.SearchByDate(searchKey, moment(new Date()).format('YYYY-MM-DD'))
                            .then((res) => {
                                this.employeeLoading = false;
                                this.employees = res.data.Data?.map((d) => ({
                                    ...d,
                                    Combine: [d.IdentityNumber, d.FullName].join(" - "),
                                }));
                            })
                            .catch((err) => {
                                console.log(err);
                                this.employeeLoading = false;
                            });
                    }, 500);
                };
                clearTimeout(this.searchOnTableTimer);
                this.searchOnTableTimer = setTimeout(() => {
                    search.call(this);
                }, 500);
            }
        },
        getLocation() {
            if (this.value.FineDate && this.value.PlateId) {
                this.gettingLocation = true;
                this.locationMessage = null;
                var data = {
                    DateTime: this.value.FineDate,
                    PlateId: this.value.PlateId,
                };
                EmployeeOperationsApi.TrafficFine.GetLocationData(data)
                    .then((res) => {
                        this.locationMessage = null;
                        if (res.data.Success) {
                            this.value.Latitude = res.data?.Data?.Latitude || null;
                            this.value.Longitude = res.data?.Data?.Longitude || null;
                            this.value.Address = res.data?.Data?.Address || null;

                            if (res.data?.Data?.EmployeeInfo) {
                                const empInfo = res.data.Data.EmployeeInfo;
                                const employeeData = {
                                    ...empInfo,
                                    Combine: [empInfo.IdentityNumber, empInfo.FullName].join(" - "),
                                };

                                const existingIndex = this.employees.findIndex((e) => e.Id === empInfo.Id);
                                if (existingIndex !== -1) {
                                    this.employees.splice(existingIndex, 1, employeeData);
                                } else {
                                    this.employees.push(employeeData);
                                }

                                this.value.EmployeeId = empInfo.Id;
                                this.value.Banka2 = empInfo.CollarStatusCode != null ? (empInfo.CollarStatusCode == "Driver" ? true : false) : false;

                                this.regNumber = empInfo.RegistrationCode || null;
                            }
                        }
                        this.gettingLocation = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.gettingLocation = false;
                    });
            }
        },
        getPlates() {
            VehicleOperationsApi.Plate.ListViaStatus(true).then((response) => {
                this.plates = response.data.Data;
            });
        },
        controlPercent(type) {
            if (type == "driver") {
                this.value.CompanyPercent = 100 - Number(this.value.DriverPercent);
            } else if (type == "company") {
                this.value.DriverPercent = 100 - Number(this.value.CompanyPercent);
            }
        },
        getTaxAdministrations() {
            SystemDataApi.TaxAdministrationList().then((res) => {
                this.taxAdministrations = res.data.Data;
            });
        },
        getBanks() {
            BankApi.List().then((res) => {
                this.banks = res.data.Data;
            });
        },
        companyAmount() {
            return ((this.value.DiscountedFineAmount ? this.value.DiscountedFineAmount : this.value.FineAmount || 0) * this.value.CompanyPercent) / 100;
        },
        personelAmount() {
            return ((this.value.DiscountedFineAmount ? this.value.DiscountedFineAmount : this.value.FineAmount || 0) * this.value.DriverPercent) / 100;
        },
    },
    computed: {
        remainingPoints() {
            const currentPoints = this.employee?.TrafficFinePoints || 0;
            return Math.max(0, 100 - currentPoints);
        },

        shouldShowWarning() {
            const currentPoints = this.employee?.TrafficFinePoints || 0;
            return currentPoints >= 80;
        },

        getPointsAlertClass() {
            const currentPoints = this.employee?.TrafficFinePoints || 0;

            if (currentPoints >= 90) {
                return "alert-danger";
            } else if (currentPoints >= 80) {
                return "alert-warning";
            } else {
                return "alert-info";
            }
        },
        isReportNumberInvalid() {
            if (!this.value.ReportNumber) {
                return false;
            }
            const pattern = /^[A-Za-z]{2}[0-9]{8}$/;
            return !pattern.test(this.value.ReportNumber);
        },
        changeDisable() {
            return this.trafficFine ? !this.trafficFine?.IsCanChangablePrice : true;
        },
        trafficFine: {
            get: function () {
                return this.trafficFines.find((b) => b.Id == this.value.TrafficFineId);
            },
            set: function (value) {
                this.value.TrafficFineId = value?.Id || null;
                this.value.FineAmount = value?.Price || 0;
                this.setDiscount();
            },
        },
        amountsMismatch() {
            const d = Number(this.value.DriverAmount || 0);
            const c = Number(this.value.CompanyAmount || 0);
            const total = Number(this.value.FineAmount || 0);
            return Math.abs(d + c - total) > 0.005;
        },
        notifyOrigin: {
            get: function () {
                return this.notifyOrigins.find((o) => o.value == this.value.NotifyOrigin);
            },
            set: function (value) {
                this.value.NotifyOrigin = value?.value ?? null;
            },
        },
        employee: {
            get: function () {
                const selectedEmployee = this.employees.find((s) => s.Id == this.value.EmployeeId);
                if (selectedEmployee) {
                    this.regNumber = selectedEmployee.RegistrationCode || null;
                }
                return selectedEmployee;
            },
            set: function (value) {
                this.value.EmployeeId = value?.Id || null;
                this.value.Banka2 = value && value.CollarStatusCode != null ? (value.CollarStatusCode == "White" ? false : true) : false;
                this.regNumber = value?.RegistrationCode || null;
            },
        },
        taxAdministration: {
            get: function () {
                return this.taxAdministrations.find((b) => b.Id == this.value.TaxAdministrationId);
            },
            set: function (value) {
                this.value.TaxAdministrationId = value?.Id || null;
            },
        },
        bank: {
            get: function () {
                return this.banks.find((b) => b.Id == this.value.BankId);
            },
            set: function (value) {
                this.value.BankId = value?.Id || null;
            },
        },
        plate: {
            get: function () {
                return this.plates.find((s) => s.Id == this.value.PlateId);
            },
            set: function (value) {
                this.value.PlateId = value?.Id || null;
            },
        },
    },
};
</script>

<style>
.traffic-fine-option {
    white-space: normal !important;
}
</style>
